import { IconProps } from "@/core/global-data/dataInterface.data";


const ErrorCircleIcon = ({ width = '48', height = '48', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Background Circle */}
                <path
                    opacity="0.4"
                    d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
                    fill="currentColor"
                />
                {/* Checkmark Path (or X Mark in this case) */}
                <path
                    d="M26.12 24.0007L30.72 19.4007C31.3 18.8207 31.3 17.8607 30.72 17.2807C30.14 16.7007 29.18 16.7007 28.6 17.2807L24 21.8807L19.4 17.2807C18.82 16.7007 17.86 16.7007 17.28 17.2807C16.7 17.8607 16.7 18.8207 17.28 19.4007L21.88 24.0007L17.28 28.6007C16.7 29.1807 16.7 30.1407 17.28 30.7207C17.58 31.0207 17.96 31.1607 18.34 31.1607C18.72 31.1607 19.1 31.0207 19.4 30.7207L24 26.1207L28.6 30.7207C28.9 31.0207 29.28 31.1607 29.66 31.1607C30.04 31.1607 30.42 31.0207 30.72 30.7207C31.3 30.1407 31.3 29.1807 30.72 28.6007L26.12 24.0007Z"
                    fill="currentColor"
                />
            </svg>
        </span>
    );
};

export default ErrorCircleIcon;
